'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var web3_js = require('@solana/web3.js');
var SdkError = require('../../errors/SdkError.cjs');

class GuestIdentityDriver {
  constructor(publicKey) {
    this.publicKey = publicKey ?? web3_js.PublicKey.default;
  }
  async signMessage() {
    throw new SdkError.OperationUnauthorizedForGuestsError('signMessage');
  }
  async signTransaction() {
    throw new SdkError.OperationUnauthorizedForGuestsError('signTransaction');
  }
  async signAllTransactions() {
    throw new SdkError.OperationUnauthorizedForGuestsError('signAllTransactions');
  }
}

exports.GuestIdentityDriver = GuestIdentityDriver;
//# sourceMappingURL=GuestIdentityDriver.cjs.map
